"use client";

import { useEffect } from "react";
import { onCLS, onFCP, onLCP, onINP, onTTFB, Metric } from "web-vitals";

export default function WebVitalsClient() {
  useEffect(() => {
    const sendToServer = (metric: Metric) => {
      //console.log("[WebVitals]", metric);

      // 서버로 전송 예시 (선택)
      fetch("/api/web-vitals", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(metric),
        keepalive: true, // 백그라운드 전송을 위해
      });
    };

    const sendToGA = ({ name, value, id }: Metric) => {
      if (typeof (window as any).gtag !== "function") return;

      (window as any).gtag("event", name, {
        value: Math.round(name === "CLS" ? value * 1000 : value), // GA에 맞게 단위 조정
        event_category: "Web Vitals",
        event_label: id, // 고유 ID
        non_interaction: true, // 전환율에 영향 없음
      });
    };

    onCLS(sendToGA);
    onFCP(sendToGA);
    onLCP(sendToGA);
    onINP(sendToGA);
    onTTFB(sendToGA);

    // onCLS(sendToServer);
    // onFCP(sendToServer);
    // onLCP(sendToServer);
    // onINP(sendToServer);
    // onTTFB(sendToServer);
  }, []);

  return null;
}
